import _ from 'lodash'

/**
 * Does a cloneDeep of all properties except the dataset property, which is
 * cloned using a shallow clone. We only do a shallow clone on the dataset
 * because cloning a large web of linked datasets locks the CPU (#55557)
 */
function cloneDeepWithDatasetShallow(obj) {
	return _.cloneDeepWith(obj, (value, key) => {
		if (key === 'dataset') {
			return _.clone(value)
		}
	})
}

export default cloneDeepWithDatasetShallow

cloneDeepWithDatasetShallow.__filename__ = 'datasets/clone-deep-with-dataset-shallow.js'
